import { useAppDispatch, useAppSelector } from "core/helpers";
import { useBaseAction } from "hooks/core";
import { useEffect } from "react";
import { setFeatures } from "store/slices/availableFeaturesSlicer";
import { API } from "../../constants/RestApi";
import { useUserRoles } from "../admin";
import { IAvailableFeatureData } from "../../components/features/types";
import { GlobalAdminRole } from "../../components/tenants/helpers/isGlobalAdmin";

type TProps = {
  fetchOnLoad: boolean;
};

const useAvailableFeaturesManagement = ({ fetchOnLoad }: TProps) => {
  const { request } = useBaseAction();
  const { currentUser, availableFeatures } = useAppSelector((state) => {
    return {
      availableFeatures: state.availableFeatures.data,
      currentUser: state.app.currentUser,
    };
  });
  const { roles } = useUserRoles({ fetchOnLoad });
  const dispatch = useAppDispatch();

  const getFeatures = async () => {
    const response = (await request({
      method: "GET",
      url: `${API.ADMIN_FEATURES}`,
      useLoader: true,
    })) as IAvailableFeatureData[];
    dispatch(setFeatures(response));
  };

  useEffect(() => {
    if (!availableFeatures.length || (fetchOnLoad && currentUser?.roles?.[0] === GlobalAdminRole)) {
      getFeatures();
    }
  }, [currentUser]);

  return {
    getFeatures,
    availableFeatures,
    roles,
  };
};

export default useAvailableFeaturesManagement;
